import React, { useState, useEffect, useRef } from "react";
import { Menu, Search } from 'lucide-react';
import { Link, useHistory } from "react-router-dom";

export default function Topbar({ onLogout, onMenuClick, user, courses }) {
  const history = useHistory();
  const [search, setSearch] = useState("");
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const searchRef = useRef();

  // Varsayılan olarak courses boş dizi olsun
  const courseList = Array.isArray(courses) ? courses : [];

  useEffect(() => {
    if (search.trim().length > 0) {
      const results = courseList.filter((course) =>
        (course.title || "")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
      setFilteredCourses(results);
      setShowDropdown(true);
    } else {
      setFilteredCourses([]);
      setShowDropdown(false);
    }
  }, [search, courses]);

  // Dropdown dışına tıklanınca kapat
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchRef.current &&
        !searchRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCourseClick = (courseId) => {
    console.log("Tıklanan kurs ID:", courseId);
    setSearch("");
    setShowDropdown(false);
    history.push(`/course/${courseId}`);
  };

  const handleAvatarClick = (e) => {
    const token = localStorage.getItem('token')
    if (!token) {
        console.log("Giriş yapılmadığı için profil isteği engellendi.");
        // İstersen doğrudan giriş sayfasına yönlendirebilirsin:
        // window.location.href = '/login';
        return;
    }
    e.stopPropagation();
    e.preventDefault();
    history.push("/profile");
  };

  return (
    <header
      style={{
        height: 64,
        background: "#fff",
        borderBottom: "1px solid #eee",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 24px",
        position: "sticky",
        top: 0,
        zIndex: 1000,
      }}
    >
      {/* Sol taraf: Logo ve menü butonu */}
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        {/* Logo - tıklanınca anasayfaya yönlendirir */}
        <div
          onClick={() => history.push("/")}
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#333",
            cursor: "pointer",
          }}
        >
            <img
              className="topbar-logo"
              src="/iyiliğin mucitlerilogo.jpg"
              alt="İyiliğin Mucitleri"
              style={{ height: 48, display: "block", objectFit: "contain", maxWidth: 180 }}
            />
            
        </div>

        {/* Menü butonu - sadece gerekirse göster */}
        {onMenuClick && (
          <button
            onClick={onMenuClick}
            style={{
              background: "none",
              border: "none",
              fontSize: 24,
              cursor: "pointer",
              display: "none",
              padding: 8,
            }}
            className="mobile-menu-btn"
          >
            <Menu className="inline-icon" />
          </button>
        )}
      </div>

      {/* Sağ taraf: Arama ve kullanıcı işlemleri */}
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        {/* Arama kutusu */}
        <div style={{ position: "relative" }} ref={searchRef}>
          <input
            type="text"
            placeholder="Search.."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onFocus={() => setShowDropdown(true)}
            style={{
              padding: "8px 16px 8px 40px",
              borderRadius: 8,
              border: "1px solid #e0e0e0",
              background: "#f8f9fa",
              outline: "none",
              width: 360,
              fontSize: 14,
            }}
          />
          <span
            style={{
              position: "absolute",
              left: 12,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#666",
            }}
          >
            <Search className="inline-icon" />
          </span>
          {/* Arama Sonuçları Dropdown */}
          {showDropdown && filteredCourses.length > 0 && (
            <div
              style={{
                position: "absolute",
                top: 40,
                left: 0,
                width: "100%",
                background: "#fff",
                border: "1px solid #e0e0e0",
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                zIndex: 1001,
                maxHeight: 240,
                overflowY: "auto",
              }}
            >
              {filteredCourses.map((course) => (
                <div
                  key={course._id}
                  onClick={() => handleCourseClick(course._id)}
                  style={{
                    padding: "10px 16px",
                    cursor: "pointer",
                    borderBottom: "1px solid #f0f0f0",
                    fontSize: 14,
                    color: "#333",
                  }}
                  onMouseDown={e => e.preventDefault()}
                >
                  {course.title}
                </div>
              ))}
            </div>
          )}
          {showDropdown && search && filteredCourses.length === 0 && (
            <div
              key="no-results"
              style={{
                position: "absolute",
                top: 40,
                left: 0,
                width: "100%",
                background: "#fff",
                border: "1px solid #e0e0e0",
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                zIndex: 1001,
                fontSize: 14,
                color: "#888",
                padding: "12px 16px",
              }}
            >
              Sonuç bulunamadı.
            </div>
          )}
        </div>

        {/* Kullanıcı giriş yapmışsa bilgilerini ve çıkış butonunu göster */}
        {user ? (
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            {/* Avatar ve kullanıcı adı */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                background: "#f8f9fa",
                padding: "6px 12px 6px 6px",
                borderRadius: 24,
                cursor: "pointer",
                border: "1px solid #e0e0e0",
              }}
              onClick={handleAvatarClick}
            >
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  background:
                    "linear-gradient(135deg, #42a947ff 0%, #84982cff 100%)",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                {user.name?.charAt(0)?.toUpperCase() || "K"}
              </div>
              <span
                style={{
                  fontWeight: 500,
                  color: "#333",
                  fontSize: 14,
                }}
              >
                {user.name || "Kullanıcı"}
              </span>
            </div>

            {/* Çıkış butonu */}
            <button
              onClick={onLogout}
              style={{
                background: "transparent",
                color: "#666",
                border: "1px solid #e0e0e0",
                borderRadius: 6,
                padding: "8px 16px",
                fontWeight: 500,
                cursor: "pointer",
                fontSize: 14,
              }}
            >
              Çıkış Yap
            </button>
          </div>
        ) : (
          // Kullanıcı giriş yapmamışsa giriş butonunu göster
          <Link to="/login" style={{ textDecoration: "none" }}>
            <button
              style={{
                padding: "8px 20px",
                borderRadius: 6,
                border: "1px solid #e0e0e0",
                background: "transparent",
                color: "#333",
                fontWeight: 500,
                cursor: "pointer",
                fontSize: 14,
              }}
            >
              Sign In
            </button>
          </Link>
        )}
      </div>

      <style>{`
        @media (max-width: 768px) {
          .mobile-menu-btn {
            display: block !important;
          }
          nav {
            display: none !important;
          }
          input {
            width: 160px !important;
          }
          .topbar-logo {
            height: 36px !important;
            max-width: 140px !important;
          }
        }
        @media (max-width: 1024px) {
          input {
            width: 240px !important;
          }
        }
        @media (max-width: 480px) {
          .topbar-logo {
            height: 32px !important;
            max-width: 120px !important;
          }
        }
      `}</style>
    </header>
  );
}
